import * as ActionType from '../constants/constant_action_types';

const defaultState = {
  resetPasswordSent: false,
};

export function employeeReducer(state=defaultState, action) {
  switch (action.type) {
    case ActionType.EMPLOYEE_REGISTERPIN_CHANGED:
      return {...state, register_pin: action.register_pin};
    case ActionType.EMPLOYEE_PASSWORD_RESET_SENT:
      return {...state, resetPasswordSent: true};
    case ActionType.CLEAR_EMPLOYEE:
      return { ...defaultState };
    default:
      return state;
  }
}
